import React, { useEffect, useState } from "react";
import doctorConsulting from "../assets/doctor-consulting.png";
import consultantData from "../constants/consultantData";
import OurStoryImg from "./OurStoryImg";
import done from "../assets/Done.png";

const OurStory = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    function handleResize (){
      if (window.innerWidth < 767){
        setIsMobile(true)
      }else{
        setIsMobile(false)
      }

      if (window.innerWidth > 767){
        setIsDesktop(true)
      }else{
        setIsDesktop(false)
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    }
  }, []);

  return (
    <>
      {/* <div className="mx-auto text-center sm:text-left  xl:px-[120px] md:px-[30px] sm:px-[30px]  ">
        <div className="text-center px-6">
          <p className="text-[#B70303] font-bold text-[15px] p-2">
            EFFICIENT SOLUTIONS FOR STREAMLINED HOSPITAL ADMINSTRATION
          </p>
          <div className="flex justify-center items-center">
            <p className="font-bold  md:text-[30px] lg:text-[35px] text-center text-[23px] lg:w-[758px]">
              We deliver <span className="underline">reliable value</span> for
              hospital administrators
            </p>
          </div>
        </div>
        <div className="lg:flex lg:flex-row-2 mt-12 w-full justify-between items-center">
          <div className="lg:w-11/12">
            {consultantData.map((ele, i) => (
              <div
                className={` text-center ${
                  ele.id === 0
                    ? 'hover:bg-red-100 hover:rounded-md	'
                    : ele.id === 1
                    ? 'hover:bg-green-100 hover:rounded-md'
                    : 'hover:bg-blue-100 '
                }`}
                key={ele.id}
              >
                <div className="lg:flex lg:px-30">
                  <div className="mt-4  flex justify-center items-start">
                    <img
                      src={ele.image}
                      alt=""
                      className={`p-2 object-cover ${
                        ele.id === 0
                          ? 'bg-red-100 rounded-full'
                          : ele.id === 1
                          ? 'bg-green-100 rounded-full'
                          : 'bg-blue-100 rounded-full'
                      }`}
                    />
                  </div>
                  <div className="lg:text-left lg:items-center md:text-center p-4 w-full mb-4">
                    <p className="text-[#b70303] font-bold text-[20px] lg:text-lg ">
                      {ele.title}
                    </p>
                    <p className="font-normal lg:text-[18px] font-lato text-[#12141d] xl:text-left md:text-center sm:text-center">
                      {ele.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="mb-4 lg:w-7/12 rounded p-5">
            <img
              src={doctorConsulting}
              alt="consulting doctor"
            className="lg:h-[320px]"
            />
          </div>
        </div>
      </div> */}

      <div className="flex flex-col px-3 pl-3 pt-5 md:flex-row justify-evenly items-center ">
        
        {isDesktop && <OurStoryImg />}
      
        <div className="">
          <div className="flex flex-col justify-start items-center md:items-start md:gap-10">
            <p className="text-[30px] mb-0 leading-10 md:text-[32px] sm:text-[5px] font-lato font-extrabold mb-5">
              <strong>
                <span className="underline text-[#B70303]">More benefits</span>
                <span className="ml-4">for</span>
                <br className="" />
                your hospital staff
              </strong>
            </p>

            <p className="font-lato text-[18px] mb-5 text-center md:text-left md:text-[25px] md-leading-15 md:mb-10">
              Maximise your resources with budget-friendly{" "}
              <br className="hidden md:inline" />
              bulk prices, split deliveries for on-demand use, &{" "}
              <br className="hidden md:inline" />
              0% interest loan options.
            </p>
          </div>

          <div className="flex justify-center md:justify-start gap-5 mt-5">
            <div className="flex flex-col font-bold justify-evenly whitespace-nowrap">
              <div className="mb-3">
                {" "}
                <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                  <img src={done} alt="" />
                </div>
                <p className="relative ml-6 font-lato text-[14px] md:text-lg md:ml-10">
                  Credit Line Options
                </p>
              </div>
              <div className="gap-3">
                {" "}
                <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                  <img src={done} alt="" />
                </div>
                <p className="relative ml-6 font-lato text-[14px] md:text-lg md:ml-10">
                  Cost Efficient
                </p>
              </div>
            </div>

            <div className="flex flex-col font-bold justify-evenly whitespace-nowrap">
              <div className="mb-3">
                {" "}
                <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                  <img src={done} alt="" />
                </div>
                <p className="relative ml-6 font-lato text-[14px] md:text-lg md:ml-10">
                  No Breaks, No Holidays
                </p>
              </div>
              <div className="gap-3">
                {" "}
                <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                  <img src={done} alt="" />
                </div>
                <p className="relative ml-6 font-lato text-[14px] md:text-lg md:ml-10">
                  Scheduling Options
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
        {isMobile && <OurStoryImg  />}
        </div>
        
        
      </div>
    </>
  );
};

export default OurStory;
